import React from 'react';
import { T } from '../../../i18n/social';

export default function SocialStepConsultationType({ lang = 'de', selected, onSelect, badge }) {
  const t = T[lang]?.booking || T['de'].booking;

  const types = [
    {
      id: 'onsite',
      label: t.onsiteLabel,
      desc: t.onsiteDesc,
      recommended: true,
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      ),
    },
    {
      id: 'phone',
      label: t.phoneLabel,
      desc: t.phoneDesc,
      recommended: false,
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6.29 6.29l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
      ),
    },
  ];

  return (
    <div className="booking-card step-enter">
      <div className="step-badge">{badge}</div>
      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '26px', fontWeight: 700,
        color: '#1e2b38', marginBottom: '8px', lineHeight: 1.2, letterSpacing: '-0.02em' }}>
        {t.typeTitle}
      </h2>
      <p style={{ fontSize: '14px', color: '#6b7a8d', marginBottom: '24px', fontFamily: 'var(--font-ui)' }}>
        {t.typeSub}
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {types.map(type => {
          const isSelected = selected === type.id;
          return (
            <div key={type.id} onClick={() => onSelect(type.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: '16px',
                padding: '20px', borderRadius: '16px', cursor: 'pointer',
                border: isSelected ? '1.5px solid #3E4954' : '1.5px solid #dde1e7',
                background: isSelected ? 'rgba(62,73,84,0.06)' : '#f8f9fa',
                transition: 'all 150ms ease',
                transform: isSelected ? 'scale(1.01)' : 'scale(1)',
                boxShadow: isSelected ? '0 4px 20px rgba(62,73,84,0.12)' : 'none',
                WebkitTapHighlightColor: 'transparent',
              }}>
              <div style={{
                width: '48px', height: '48px', borderRadius: '12px', flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: isSelected ? '#3E4954' : '#eef0f3',
                color: isSelected ? '#ffffff' : '#6b7a8d',
                transition: 'all 150ms ease',
              }}>
                {type.icon}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '4px' }}>
                  <span style={{ fontWeight: 700, fontSize: '16px', color: '#1e2b38', fontFamily: 'var(--font-ui)' }}>
                    {type.label}
                  </span>
                  {type.recommended && (
                    <span style={{ fontSize: '10px', fontWeight: 700, padding: '2px 8px',
                      borderRadius: '100px', background: '#e8edf1', color: '#3E4954',
                      letterSpacing: '0.04em', fontFamily: 'var(--font-ui)' }}>
                      {t.recommended}
                    </span>
                  )}
                </div>
                <p style={{ fontSize: '13px', color: '#6b7a8d', margin: '0 0 6px',
                  fontFamily: 'var(--font-ui)', lineHeight: 1.4 }}>
                  {type.desc}
                </p>
                <p style={{ fontSize: '13px', color: '#22863a', margin: 0, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
                  {t.free}
                </p>
              </div>
              <div style={{
                width: '22px', height: '22px', borderRadius: '50%', flexShrink: 0,
                border: isSelected ? '2px solid #3E4954' : '2px solid #c5cdd6',
                background: isSelected ? '#3E4954' : 'transparent',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'all 150ms ease',
              }}>
                {isSelected && (
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
